import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import { Link, Redirect } from "react-router-dom";
import { Notification } from "ui/notification";
import * as QS from "util/query-string";
import { getErrorMessage } from "util/response";

class ResetPasswordPage extends React.Component {
  static get propTypes() {
    return {
      location: PropTypes.object.isRequired,
      onResetPassword: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
    };
  }

  constructor(props) {
    super(props);

    const { location } = props;
    const parsed = QS.parse(location.search);

    this.state = {
      errorMessage: "",
      p1: "",
      p2: "",
      passwordChanged: false,
      token: parsed.token,
    };

    this.doResetPassword = this.doResetPassword.bind(this);
    this.onUpdateP1 = this.onUpdateP1.bind(this);
    this.onUpdateP2 = this.onUpdateP2.bind(this);
  }

  onUpdateP1(e) {
    this.setState({ p1: e.target.value });
  }

  onUpdateP2(e) {
    this.setState({ p2: e.target.value });
  }

  doResetPassword() {
    const { onResetPassword } = this.props;
    const { p1, p2, token } = this.state;

    return onResetPassword(token, p1, p2)
      .then(() => {
        this.setState({
          errorMessage: "",
          passwordChanged: true,
        });
      })
      .catch((resp) => {
        this.setState({
          errorMessage: getErrorMessage(resp, "Failed to reset password."),
        });
      });
  }

  _renderSuccess() {
    return (
      <div className="login-box-body">
        <p>Your password has changed successfully.</p>
        <Link to="/login">Login</Link>
      </div>
    );
  }

  _renderForm() {
    const { errorMessage } = this.state;

    return (
      <div className="login-box-body">
        <p className="login-box-msg">Enter your new password</p>
        <Notification error={errorMessage} />
        <FormGroup>
          <FormControl
            type="password"
            placeholder="New Password"
            onChange={this.onUpdateP1}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            type="password"
            placeholder="New Password (again)"
            onChange={this.onUpdateP2}
          />
        </FormGroup>
        <Row>
          <Col xs={{ span: 5, offset: 7 }}>
            <Button variant="primary" onClick={this.doResetPassword}>
              Set New Password
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  _renderLoginBoxBody() {
    const { passwordChanged } = this.state;

    return passwordChanged ? this._renderSuccess() : this._renderForm();
  }

  render() {
    const { title } = this.props;
    const { token } = this.state;

    if (!token) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="login-page">
        <div className="header">
          <h1>{title}</h1>
        </div>
        <div className="login-box">{this._renderLoginBoxBody()}</div>
      </div>
    );
  }
}

export { ResetPasswordPage };
